import React, { useEffect, useState } from 'react';
import useHotSpot from '@hooks/useHotSpot';

function Divider() {
  return (
    <div className="font-rp-basetica leading-7 text-2xl text-rp-black -tracking-0.48px">:</div>
  );
}

function DigitCountdown({ digit, unit }: { digit: number; unit: string }) {
  const formattedDigit = digit < 10 ? `0${digit}` : digit.toString();

  return (
    <div className="bg-rp-red-3 flex h-12 items-center justify-center rounded-4 w-17">
      <div className="flex align-baseline">
        <span className="leading-9 font-light text-32 text-rp-inverted -tracking-0.64px">
          {formattedDigit}
        </span>

        <span className="leading-6 text-rp-light-red-2 text-xl tracking-2">{unit}</span>
      </div>
    </div>
  );
}

type Props = {
  targetDate: Date;
};

export default function HotSpotCountdown({ targetDate }: Props) {
  const { calculateTimeLeft } = useHotSpot();

  const initialTimeLeft = calculateTimeLeft(targetDate);
  const [timeLeft, setTimeLeft] = useState(initialTimeLeft);

  useEffect(() => {
    const intervalId = setInterval(() => {
      const updatedTimeLeft = calculateTimeLeft(targetDate);
      setTimeLeft(updatedTimeLeft);
    }, 1000);

    return () => clearInterval(intervalId);
  }, [targetDate, calculateTimeLeft]);

  return (
    <div className="flex items-center space-x-1">
      <DigitCountdown digit={timeLeft.days} unit="D" />
      <Divider />
      <DigitCountdown digit={timeLeft.hours} unit="H" />
      <Divider />
      <DigitCountdown digit={timeLeft.minutes} unit="M" />
      <Divider />
      <DigitCountdown digit={timeLeft.seconds} unit="S" />
    </div>
  );
}
